/**
* DevExpress Dashboard (_chart-item.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { parseBool, PropertyCategory } from '../../../metadata/_base-metadata';
import { chartItemBaseSerializationsInfo } from '../../metadata/_chart-item-base';
import { _chartItemInteractivityOptionsMeta } from '../../options/interactivity-options';
import { ChartAxisX } from '../chart-axis';
import { ChartLegend } from '../chart-legend';
export let chartRotated = { propertyName: 'rotated', modelName: '@Rotated', displayName: 'DashboardWebStringId.Chart.Rotated', defaultVal: false, simpleFormAdapterItem: 'onOffButtonGroupEditor', from: parseBool, category: PropertyCategory.ViewModel };
export let panes = { propertyName: 'panes', modelName: 'Panes', displayName: 'DashboardWebStringId.Chart.Panes', array: true };
export let chartIndicators = { propertyName: 'indicators', modelName: 'Indicators', array: true };
export let chartLegend = { propertyName: 'legend', modelName: 'ChartLegend', displayName: 'DashboardWebStringId.Chart.Legend', type: ChartLegend };
export let chartAxisX = { propertyName: 'axisX', modelName: 'AxisX', displayName: 'DashboardWebStringId.Chart.AxisX', type: ChartAxisX };
export let chartItemSerializationInfo = chartItemBaseSerializationsInfo.concat([panes, chartIndicators, chartRotated, chartLegend, chartAxisX, _chartItemInteractivityOptionsMeta]);
